import { modelHeroCarousel } from '~/models/content/hero-carousel.js'

export const modelExplore = (data) => {
  return {
    hero: modelHeroCarousel(data),
    title: data.title,
    navigation: modelExploreNav(data.categories),
    meta: data.meta
  }
}

export const modelExploreNav = categories => categories.map(
  category => ({
    ...category,
    slug: `/explore/${category.slug}`
  }
))
